import { createModel } from "nyax";
import { Device, DeviceQuery } from "src/models/device";
import { PackageQuery } from "src/models/package";
import { DeviceEntityModel } from "src/store/models/entity/device/entity";
import { createUISideListWithPermissionModel } from "src/store/models/ui/_shared";

export const DeviceSideUIModel = createModel(
  class extends createUISideListWithPermissionModel<Device, DeviceQuery>({
    setItems: (getContainer, items) =>
      getContainer(DeviceEntityModel).actions.setItems.dispatch(items),
    getItems: (getContainer) => getContainer(DeviceEntityModel).getters.items,
    getItem: (getContainer, id) =>
      getContainer(DeviceEntityModel).state.byId[id],
    getItemId: (item) => item.id,
  }) {
    public effects() {
      return {
        ...super.effects(),
        initial: async (payload: { departmentId: string }) => {
          const { departmentId } = payload;
          this._initial({
            initialAction: (
              pageIndex: number,
              pageSize: number,
              query: PackageQuery
            ) =>
              this.dependencies.serviceClient.device.list(
                departmentId,
                pageIndex,
                pageSize,
                query
              ),
          });
        },
      };
    }
  }
);
